import { render, staticRenderFns } from "./TorontoCHMB41HQuiz4Question2.vue?vue&type=template&id=4f8fa8e6&scoped=true&"
import script from "./TorontoCHMB41HQuiz4Question2.vue?vue&type=script&lang=ts&"
export * from "./TorontoCHMB41HQuiz4Question2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f8fa8e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VFileInput,VForm,VImg,VRow})
